module.exports = __webpack_public_path__ + "img/oakley-capital.eb53561a.jpg";